import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { SnotifyModule, ToastDefaults } from 'ng-snotify';

import { BlAppContext, BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  BlNgShareCommonModule,
  BrowserCheckModule,
  CustomerVehicleHeaderModule,
  DealsMemoModule,
  RecallInfoModalModule,
  ReceptionListModalModule,
  AddressGuideModule,
  PostalCodeInputModule,
  PrintConfirmGuideModule,
  GenericPrintModule,
  LabelModule,
  MultiEmployeeGuideModule,
  EmployeeGuideModule,
  SetMenuSelectGuideModule,
  DiscountSelectGuideModule,
  CancelModalModule,
  ShowAgainConfirmModalModule,
  ScheduleTimeTableModule,
  UserGuideModule,
  RemarkGuideModule,
  WarehouseGuideModule,
  SalesPriceProcessDivSettingGuideModule,
  WeightTaxInquiryModule,
  GlassLaborRateGuideModule,
  DotNumberGuideModule,
  RemarksInfoGuideModule,
  TicketGuideModule,
  ContactMemoGuideModule,
  DateModalModule,
  SendSingleMessageModalModule,
  OnlineSalesSettingDetailModule,
  CustomerSearchModule,
  SnsChatWindowModule,
  MaintenanceSheetPrintModule,
  PrintPreviewModalModule
} from '@blcloud/bl-ng-share-module';
import {
  TransportBranchGuideModule,
  MakerModelGuideModule,
  InsurCompanyGuideModule,
  RepVehicleEntryModalModule,
  SimpleMakerModelGuideModule,
  VclePridicExchgSimuTabContainerModule,
  VehicleInfoModule,
  BlNgVehicleCustomerModule,
  RepVehicleReceptionLinkModalModule,
  CustomerEntryContainerModalModule,
  ReplacementModalModule,
  CustomerGuideModule, CustomerSnsQrOcrModalModule, SnsLinkChangeConfirmModalModule, SnsLinkConflictModalModule
} from '@blcloud/bl-ng-vehicle-customer-module';
import { SlipSearchModule } from '@blcloud/bl-ng-slip-module';
import { ReceptExclusiveModule, ReceptEntryModule } from '@blcloud/bl-ng-recept-module';

import { environment } from '../environments/environment';
import { config } from '../configs/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageModule } from './page/login-page/login-page.module';
import { RedirectPageModule } from './page/redirect-page/redirect-page.module';
import { SettingManagementService } from './shared/setting-management/setting-management.service';
import { ReservePrintModalModule } from './feature/reserve-print-modal';
import { WebReserveCustomerVehicleLinkModule } from './feature/web-reserve-customer-vehicle-link';
import { WebReserveReceptionLinkModule } from './feature/web-reserve-reception-link';
import { WebReserveDetailModule } from './feature/web-reserve-detail';
import { ContactAlertSettingModalModule } from './feature/contact-alert-setting/contact-alert-setting-modal.module';
import { ContactBgColorSettingModalModule } from './feature/contact-bg-color-setting/contact-bg-color-setting-modal.module';
import { ContactInitSettingModalModule } from './feature/contact-init-setting/contact-init-setting-modal.module';
import { NotifyToastService } from './shared/notify-toast/notify-toast.service';
import { ResultFormModalModule } from './page/call-list-page/result-form-modal/result-form-modal.module';
import { EditModalModule } from './page/contact-list-page/modal/edit-modal.module';
import { ProfileEntriesPageModule } from './page/profile-entries-page/profile-entries-page.module';
import { SnsSendMessageModalModule } from './feature/sns-send-message-modal/sns-send-message-modal.module';
import { SnsSendMessageConfirmModalModule } from './feature/sns-send-message-confirm-modal/sns-send-message-confirm-modal.module';
import { FaceDetectionModalModule } from './feature/face-detection-modal/face-detection-modal.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SnotifyModule.forRoot(),
    BlNgCommonModule.forRoot(),
    BlNgUiComponentModule.forRoot(),
    BlNgShareCommonModule.forRoot(),
    BrowserCheckModule.forRoot(),

    // LazyLoadするModuleが利用する各種Modal/Guideが所属するEntryComponentをあわせるために必要なimport
    TransportBranchGuideModule.forRoot(),
    CustomerVehicleHeaderModule.forRoot(),
    DealsMemoModule.forRoot(),
    RecallInfoModalModule.forRoot(),
    ReceptionListModalModule.forRoot(),
    MakerModelGuideModule.forRoot(),
    InsurCompanyGuideModule.forRoot(),
    RepVehicleEntryModalModule.forRoot(),
    SimpleMakerModelGuideModule.forRoot(),
    VclePridicExchgSimuTabContainerModule.forRoot(),
    VehicleInfoModule.forRoot(),
    BlNgVehicleCustomerModule.forRoot(),
    AddressGuideModule.forRoot(),
    PostalCodeInputModule.forRoot(),
    PrintConfirmGuideModule.forRoot(),
    GenericPrintModule.forRoot(),
    LabelModule.forRoot(),
    MultiEmployeeGuideModule.forRoot(),
    EmployeeGuideModule.forRoot(),
    SetMenuSelectGuideModule.forRoot(),
    DiscountSelectGuideModule.forRoot(),
    CancelModalModule.forRoot(),
    RepVehicleReceptionLinkModalModule.forRoot(),
    ShowAgainConfirmModalModule.forRoot(),
    ReceptExclusiveModule.forRoot(),
    CustomerEntryContainerModalModule.forRoot(),
    WeightTaxInquiryModule.forRoot(),
    GlassLaborRateGuideModule.forRoot(),
    SlipSearchModule.forRoot(),
    DotNumberGuideModule.forRoot(),
    ScheduleTimeTableModule.forRoot(),
    ReservePrintModalModule.forRoot(),
    WebReserveCustomerVehicleLinkModule.forRoot(),
    WebReserveReceptionLinkModule.forRoot(),
    WebReserveDetailModule.forRoot(),
    TicketGuideModule.forRoot(),
    ReceptEntryModule.forRoot(),
    ReplacementModalModule.forRoot(),
    DateModalModule.forRoot(),
    SendSingleMessageModalModule.forRoot(),
    ContactAlertSettingModalModule.forRoot(),
    ContactBgColorSettingModalModule.forRoot(),
    ContactInitSettingModalModule.forRoot(),
    ResultFormModalModule,
    EditModalModule.forRoot(),
    SnsChatWindowModule.forRoot(),
    CustomerGuideModule.forRoot(),
    CustomerSearchModule.forRoot(),
    CustomerSnsQrOcrModalModule.forRoot(),
    SnsLinkChangeConfirmModalModule.forRoot(),
    SnsLinkConflictModalModule.forRoot(),
    MaintenanceSheetPrintModule.forRoot(),
    PrintPreviewModalModule.forRoot(),

    AppRoutingModule,
    LoginPageModule,
    RedirectPageModule,
    UserGuideModule.forRoot(),
    RemarkGuideModule.forRoot(),
    WarehouseGuideModule.forRoot(),
    SalesPriceProcessDivSettingGuideModule.forRoot(),
    ContactMemoGuideModule.forRoot(),
    ProfileEntriesPageModule.forRoot(),
    RemarksInfoGuideModule.forRoot(),
    OnlineSalesSettingDetailModule.forRoot(),
    SnsSendMessageModalModule,
    SnsSendMessageConfirmModalModule,
    FaceDetectionModalModule.forRoot(),
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    Title,
    SettingManagementService,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    NotifyToastService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  /**
   * コンストラクタ
   * @param context コンテキスト
   */
  constructor(context: BlAppContext) {
    // 設定を保持
    context.environment = environment;
    context.config = config;
  }
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts